// Lity: a ultra-lightweight, accessible and responsive lightbox plugin (https://www.npmjs.com/package/lity || https://sorgalla.com/lity/)

const $ = window.jQuery;
